var map = {
	"./Application.jpg": 2316,
	"./Game.jpg": 2317,
	"./Music.jpg": 2318,
	"./Video.jpg": 2319,
	"./Wallpaper.jpg": 2320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2315;


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutehub/imgs/browse ^\.\/.*\.jpg$
// module id = 2315
// module chunks = 0